var map = {
	"./404.svg": 985,
	"./Categories.png": 734,
	"./Edit-menu.svg": 986,
	"./Egg.svg": 987,
	"./Emaier-Header.png": 988,
	"./Qr-4.png": 989,
	"./_duplicate.svg": 990,
	"./_overview.svg": 991,
	"./add-white.svg": 992,
	"./alert.svg": 993,
	"./all_category.svg": 994,
	"./archive.svg": 995,
	"./armchair.svg": 996,
	"./arrow-circle-right.svg": 997,
	"./arrow-left-circle.svg": 998,
	"./arrow-right-circle.svg": 999,
	"./arrow-right.svg": 1000,
	"./asc-up-white.svg": 1001,
	"./asc.png": 1002,
	"./asc.svg": 1003,
	"./back-arrow.svg": 1004,
	"./barcode-icon.svg": 1005,
	"./beverages.svg": 1006,
	"./blue-edit-pen.svg": 1007,
	"./blue-eye.svg": 1008,
	"./box-office.svg": 1009,
	"./broken-seat.jpg": 1010,
	"./calendar_list.svg": 1011,
	"./calender.svg": 376,
	"./chevron-down.svg": 1012,
	"./chevron-left.svg": 1013,
	"./cinema-mamagement-sidebar.svg": 1014,
	"./claendar.svg": 377,
	"./clock-1.svg": 1015,
	"./clock.svg": 1016,
	"./close-button.svg": 741,
	"./close-white.svg": 747,
	"./close-x.svg": 321,
	"./collapse-up.svg": 1017,
	"./collapse.svg": 1018,
	"./connection-lost.svg": 374,
	"./consumable-raw-material.svg": 1019,
	"./copy.svg": 1020,
	"./copy_image_icon.png": 1021,
	"./delete-red-light.svg": 1022,
	"./delete-red.svg": 748,
	"./delete.svg": 722,
	"./deliver-icon.svg": 1023,
	"./desc-down-white.svg": 1024,
	"./desc.svg": 1025,
	"./distributors-sidebar.svg": 1026,
	"./download.svg": 1027,
	"./dragndrop.svg": 1028,
	"./dragndrop2.svg": 1029,
	"./duplicate.svg": 1030,
	"./duplicateScreen.svg": 1031,
	"./e-wallet-icon-black.svg": 1032,
	"./edit-pen-blue.svg": 1033,
	"./edit-pen-white.svg": 1034,
	"./edit-pen.svg": 1035,
	"./edit.svg": 1036,
	"./email.png": 1037,
	"./empty-image.svg": 1038,
	"./excel.svg": 1039,
	"./external-link.svg": 1040,
	"./eye.svg": 1041,
	"./filter-icon.svg": 1042,
	"./flag.svg": 1043,
	"./fnb-app-order.svg": 1044,
	"./fnb-beverages.svg": 1045,
	"./fnb-brownie.svg": 1046,
	"./fnb-combo.svg": 1047,
	"./fnb-desert.svg": 1048,
	"./fnb-eatables.svg": 1049,
	"./fnb-make-your-combo.svg": 1050,
	"./fnb-popcorn.svg": 1051,
	"./fnbtransactionIcon.svg": 1052,
	"./fullscreen-icon.svg": 749,
	"./funnel.svg": 1053,
	"./globe.svg": 1054,
	"./green-tick.svg": 1055,
	"./grid-view.svg": 1056,
	"./hide-password.svg": 378,
	"./home-icon.svg": 1057,
	"./home.svg": 1058,
	"./icon-black-play.svg": 1059,
	"./icon-dot.svg": 1060,
	"./icon-fnb.svg": 1061,
	"./icon-marketing.svg": 1062,
	"./icon-no-seat.png": 1063,
	"./icon-no-seat.svg": 1064,
	"./icon-option.svg": 1065,
	"./icon-poin-of-sale.svg": 1066,
	"./icon-recliner.svg": 1067,
	"./icon-report.svg": 1068,
	"./icon-sofa-dark-1.svg": 1069,
	"./icon-sofa-dark.png": 1070,
	"./icon-sofa-dark.svg": 1071,
	"./icon-sofa.svg": 1072,
	"./importfile.svg": 1073,
	"./info.svg": 750,
	"./info2.svg": 1074,
	"./keyboard-icon.svg": 1075,
	"./kitchen_display.svg": 1076,
	"./language-icon.svg": 1077,
	"./left-caret.svg": 1078,
	"./link.svg": 1079,
	"./list-view.svg": 1080,
	"./loading.svg": 379,
	"./lock.svg": 1081,
	"./login-password.png": 380,
	"./login-user.png": 381,
	"./logout.svg": 751,
	"./masters-sidebar.svg": 1082,
	"./merchandise.svg": 1083,
	"./minus.svg": 1084,
	"./movie-pass-svg.svg": 732,
	"./movie-rolling.svg": 1085,
	"./mulitSchedule.svg": 1086,
	"./multicurrency.svg": 1087,
	"./multifnb.svg": 1088,
	"./nav-plus.svg": 1089,
	"./new_filter_icon.svg": 1090,
	"./no-image.svg": 1091,
	"./no-schedule.svg": 149,
	"./non-veg-mark.png": 1092,
	"./non-veg-mark.svg": 1093,
	"./notification.svg": 1094,
	"./open-link-blue.svg": 1095,
	"./openPlanned.svg": 1096,
	"./overview.svg": 1097,
	"./overview2.svg": 1098,
	"./pdf-icon.svg": 1099,
	"./pdf.svg": 1100,
	"./pickup-ticket-icon.svg": 1101,
	"./pickupfnb.svg": 1102,
	"./play.svg": 1103,
	"./plus.svg": 1104,
	"./pointofsale-1.svg": 1105,
	"./pointofsale-2.svg": 1106,
	"./pointofsale.png": 1107,
	"./portfolio.svg": 1108,
	"./pos-fnb-no-itmes.svg": 735,
	"./pos-refresh.svg": 1109,
	"./primary/chevron-down.svg": 1110,
	"./primary/download.svg": 1111,
	"./primary/edit.svg": 1112,
	"./primary/filter.svg": 1113,
	"./primary/printer.svg": 1114,
	"./print-icon.svg": 1115,
	"./print.svg": 1116,
	"./question.svg": 1117,
	"./question1.svg": 1118,
	"./question2.svg": 752,
	"./question3.svg": 1119,
	"./recliner-1.svg": 1120,
	"./recliner.png": 1121,
	"./refund-icon.svg": 1122,
	"./reload-icon-pos.svg": 1123,
	"./reload-icon.svg": 1124,
	"./restore.svg": 1125,
	"./right-caret.svg": 1126,
	"./role-management-sidebar.svg": 1127,
	"./save.svg": 1128,
	"./schedule-icon.svg": 1129,
	"./school-calendar.svg": 1130,
	"./search-global-white.svg": 1131,
	"./search-global.svg": 1132,
	"./search.svg": 753,
	"./searchIcon.svg": 1133,
	"./seat-icon-2.svg": 1134,
	"./seat-icon.svg": 1135,
	"./seat-icons/3-wheelChair.png": 1136,
	"./seat-icons/block_seat_new.png": 1137,
	"./seat-icons/broken-seat-1.svg": 1138,
	"./seat-icons/broken-seat-2.svg": 1139,
	"./select-food.png": 754,
	"./settings.svg": 1140,
	"./show-password.svg": 382,
	"./slider-triangle.svg": 744,
	"./snack.svg": 755,
	"./sort.svg": 1141,
	"./star-empty.svg": 1142,
	"./star-fill.svg": 1143,
	"./success-tick.svg": 1144,
	"./suitcase.svg": 1145,
	"./swap.svg": 1146,
	"./tick-green-item.svg": 756,
	"./tick-green.svg": 1147,
	"./ticket-icon.svg": 1148,
	"./trash.svg": 1149,
	"./unpaid-reservation.svg": 726,
	"./updown-white.svg": 1150,
	"./updown.svg": 1151,
	"./user-attribute.svg": 1152,
	"./user-attributes.svg": 1153,
	"./user-female.svg": 1154,
	"./user-male-white.svg": 1155,
	"./user-male.svg": 1156,
	"./user-profile.svg": 1157,
	"./userProfile.png": 1158,
	"./veg-food-mark-white.png": 1159,
	"./veg-foog-mark-trans.png": 1160,
	"./view.png": 1161,
	"./view.svg": 1162
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 984;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 984
// module chunks = 38